import React from 'react'

type Props = {
  children: React.ReactChild
  wide?: boolean
  centered?: boolean
}

const ContentArea = ({ centered, wide, children }: Props) => {
  return (
    <div
      className={
        centered
          ? 'c-content-area c-content-area--centered o-width-limiter'
          : 'c-content-area o-width-limiter'
      }
    >
      <div
        className={
          wide
            ? 'c-content-area__inner c-content-area__inner--wide'
            : 'c-content-area__inner'
        }
      >
        {children}
      </div>
    </div>
  )
}

export default ContentArea
